<template>
    <div id="FAQNotinOne">
        <v-container :style="{ padding: '80px 16px' }">
            <v-row>
                <v-col cols="12" class="text-center mb-8">
                    <h2 class="faq-title" v-html="NOTARIA.Theme.Home.FAQ.Titulo.Texto"></h2>
                    <p class="faq-description" v-html="NOTARIA.Theme.Home.FAQ.Descripcion.Texto"></p>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" md="8">
                    <v-expansion-panels accordion flat class="faq-panels">
                        <v-expansion-panel
                            v-for="(faq, i) in NOTARIA.FAQs"
                            :key="i"
                            class="mb-4 faq-panel"
                        >
                            <v-expansion-panel-title expand-icon="mdi-plus" collapse-icon="mdi-minus" class="faq-question-title">
                                <span v-html="faq.Pregunta"></span>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text class="faq-question-text">
                                <span v-html="faq.Respuesta"></span>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from "pinia";
import { useStore } from '../../store/index';
import { useStyles } from '../../store/styles';

const store = useStore();
const { NOTARIA } = storeToRefs(store);
const style = useStyles();

const estiloTituloColor = computed(() => style.ThemeHomeFAQ?.Titulo?.css?.Color);
const estiloTituloFont = computed(() => style.ThemeHomeFAQ?.Titulo?.css?.Font);
const estiloTituloSize = computed(() => style.ThemeHomeFAQ?.Titulo?.css?.Size);
const estiloTituloWeight = computed(() => style.ThemeHomeFAQ?.Titulo?.css?.Weight);
const estiloTituloAlign = computed(() => style.ThemeHomeFAQ?.Titulo?.css?.Align);

const estiloDescripcionColor = computed(() => style.ThemeHomeFAQ?.Descripcion?.css?.Color);
const estiloDescripcionFont = computed(() => style.ThemeHomeFAQ?.Descripcion?.css?.Font);
const estiloDescripcionSize = computed(() => style.ThemeHomeFAQ?.Descripcion?.css?.Size);
const estiloDescripcionWeight = computed(() => style.ThemeHomeFAQ?.Descripcion?.css?.Weight);
const estiloDescripcionAlign = computed(() => style.ThemeHomeFAQ?.Descripcion?.css?.Align);

const estiloTarjetaFondo = computed(() => {
    const fondo = style.ThemeHomeFAQ?.Tarjeta?.FondoCSS;
    if(fondo?.BackgroundColorGradient){
        return "linear-gradient(to right," + (fondo.BackgroundColor || 'transparent') + "," + fondo.BackgroundColorGradient + ")";
    } else {
        return fondo?.BackgroundColor || 'var(--color-white)';
    }
});

const estiloTarjetaTituloColor = computed(() => style.ThemeHomeFAQ?.Tarjeta?.Titulo?.css?.Color);
const estiloTarjetaTituloFont = computed(() => style.ThemeHomeFAQ?.Tarjeta?.Titulo?.css?.Font);
const estiloTarjetaTituloSize = computed(() => style.ThemeHomeFAQ?.Tarjeta?.Titulo?.css?.Size);
const estiloTarjetaTituloWeight = computed(() => style.ThemeHomeFAQ?.Tarjeta?.Titulo?.css?.Weight);

const estiloTarjetaDescripcionColor = computed(() => style.ThemeHomeFAQ?.Tarjeta?.Descripcion?.css?.Color);
const estiloTarjetaDescripcionFont = computed(() => style.ThemeHomeFAQ?.Tarjeta?.Descripcion?.css?.Font);
const estiloTarjetaDescripcionSize = computed(() => style.ThemeHomeFAQ?.Tarjeta?.Descripcion?.css?.Size);
const estiloTarjetaDescripcionWeight = computed(() => style.ThemeHomeFAQ?.Tarjeta?.Descripcion?.css?.Weight);

</script>

<style scoped>
.faq-title {
    color: v-bind(estiloTituloColor) !important;
    font-size: v-bind(estiloTituloSize) !important;
    font-weight: v-bind(estiloTituloWeight) !important;
    font-family: v-bind(estiloTituloFont) !important;
    text-align: v-bind(estiloTituloAlign) !important;
}
.faq-description {
    color: v-bind(estiloDescripcionColor) !important;
    font-size: v-bind(estiloDescripcionSize) !important;
    font-weight: v-bind(estiloDescripcionWeight) !important;
    font-family: v-bind(estiloDescripcionFont) !important;
    text-align: v-bind(estiloDescripcionAlign) !important;
    margin-top: 16px;
}
.faq-panel {
    background: v-bind(estiloTarjetaFondo) !important;
    border-radius: 8px !important;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0,0,0,0.05) !important;
}
.faq-panels .v-expansion-panel-title {
    color: v-bind(estiloTarjetaTituloColor) !important;
    font-size: v-bind(estiloTarjetaTituloSize) !important;
    font-weight: v-bind(estiloTarjetaTituloWeight) !important;
    font-family: v-bind(estiloTarjetaTituloFont) !important;
    padding: 24px !important;
}
.faq-panels .v-expansion-panel-text {
    color: v-bind(estiloTarjetaDescripcionColor) !important;
    font-size: v-bind(estiloTarjetaDescripcionSize) !important;
    font-weight: v-bind(estiloTarjetaDescripcionWeight) !important;
    font-family: v-bind(estiloTarjetaDescripcionFont) !important;
    padding: 0 24px 24px 24px !important;
}
</style>
